import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
   selector: 'app-account-information',
   standalone: true,
   imports: [NgIf],
   templateUrl: './account-information.component.html',
   styleUrls: ['./account-information.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountInformationComponent {
   @Input() isLoading = false;

   @Input() planName = '—';
   @Input() commencementDate = '—';
   @Input() accountOwner = '—';

   @Input() planDetails = '—';
   @Input() features = '—';
   @Input() billingCycle = '—';
   @Input() pms = '—';
   @Input() propertyName: string = '—';
   @Input() remainingDaysLeft: number = 0;
}
